/* Copyright (c) 2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useMemo } from "react";
import { createValueLabelMap } from "~/hooks/useAppliedFilters/utils";
import { useGetAllActions } from "~/hooks/useGetAllActions";
import { createPlansAppliedFilters } from "../components/plansAppliedFilters";

export function usePlansAppliedFilters() {
  const { customActions, systemActions } = useGetAllActions();

  const planActionNamesById = useMemo(
    () =>
      createValueLabelMap(
        [...systemActions, ...customActions],
        (action) => action.id,
        (action) => action.name
      ),
    [customActions, systemActions]
  );

  return useMemo(
    () => createPlansAppliedFilters(planActionNamesById),
    [planActionNamesById]
  );
}
